<template lang="pug">
  div
    div(v-if="loaded && !isNdiBa")
      analisar-validar-processo(
        :responseAnalise="responseAnalise",
        :processo="processo",
        :hasAnalisePendente="hasAnalisePendente",
        :idProcesso="idProcesso",
        :acaoCaixa="acaoCaixa",
        :regras="regras",
        :active="active",
        :analiseManual="analiseManual",
        @atualizarTela="atualizarTela",
        @setActive="setActive"
      )
    div(v-if="loaded && isNdiBa")
      emitir-certidao-area(
        :regras="regras",
        :processo="processo",
        :idProcesso="idProcesso",
      )
</template>

<script>
import AnalisarValidarProcesso from './AnalisarValidarProcesso.vue'
import EmitirCertidaoArea from './EmitirCertidaoArea.vue'
import { mapActions } from 'vuex'
import acaoProcesso from '@/constants/acaoProcesso'
const regrasAnalise = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { exibirMapa, exibirModelos, exibirBotoesDecisao, statusBotoesDecisao, naoExibirModelos, podeInserirAnotacao, possuiTitulo, decisoes, exibirAnexosBloqueio, exibirAnexosMonitoramento } = regrasAnalise.cadastro

export default {
  components: {
    AnalisarValidarProcesso,
    EmitirCertidaoArea
  },

  props: {
    idProcesso: {
      required: true
    },
    acaoCaixa: {
      type: String,
      default: null
    },
    analiseManual: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      hasAnalisePendente: false,
      loaded: false,
      responseAnalise: null,
      active: 1,
      usuario: null
    }
  },

  async created () {
    const promises = []

    promises.push(this.iniciarAnalise())

    promises.push(this.getUsuario().then((usuario) => {
      this.usuario = usuario
    }))

    await Promise.all(promises)
    this.loaded = true
  },

  methods: {
    ...mapActions({
      iniciaAnaliseProcesso: 'processo/iniciaAnalise',
      getProcessoById: 'processo/getProcessoById',
      getUsuario: 'auth/getUsuario',
      checkAnalisePendente: 'processo/checkAnalisePendente'
    }),

    getAcaoAnalise () {
      switch (this.acaoCaixa) {
        case null:
          return acaoProcesso.ANALISAR
        case 'PUBLICACAO':
          return acaoProcesso.PUBLICACAO
        case 'VALIDAR':
          return acaoProcesso.VALIDAR
        case 'ANALISE_SEM_TRAMITACAO':
          return acaoProcesso.VALIDAR
        case 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO':
          return acaoProcesso.UPLOAD_TERMO_RECEBIMENTO_CONTRATO
        case 'ELABORAR_EDITAL':
          return acaoProcesso.ELABORAR_EDITAL
        default:
          return acaoProcesso.ANALISAR
      }
    },

    async iniciarAnalise () {
      this.processo = await this.getProcessoById(this.idProcesso)
      this.responseAnalise = await this.iniciaAnaliseProcesso({ idProcesso: this.idProcesso, tipoAcao: this.getAcaoAnalise() })
    },

    async atualizarTela () {
      this.loaded = false
      await this.iniciarAnalise()
      this.loaded = true
    },

    showAnaliseAutomatizada () {
      if (!this.responseAnalise?.isAnaliseAutomatizada || !this.responseAnalise?.despacho.flagAnaliseAutomatizada) {
        return false
      }

      return true
    },

    podeInserirAnotacao () {
      return podeInserirAnotacao.perfis.includes(this.usuario?.perfilSelecionado.codigo) && podeInserirAnotacao.acoes.includes(this.getAcaoAnalise())
    },

    showMapa () {
      if (this.usuario?.perfilSelecionado &&
        exibirMapa.setores.includes(this.processo.setor) &&
        exibirMapa.status.includes(this.processo?.status) && !this?.responseAnalise?.isFluxoBloqueioDinamico) {
        return true
      }
      return false
    },

    showArquivosBloqueio () {
      if (this.usuario?.perfilSelecionado &&
        exibirAnexosBloqueio.setores.includes(this.usuario?.perfilSelecionado.setor.codigo) && this?.responseAnalise?.isFluxoBloqueioDinamico) {
        return true
      }
      return false
    },

    showArquivosMonitoramento () {
      if (this.usuario?.perfilSelecionado &&
      exibirAnexosMonitoramento.setores.includes(this.usuario?.perfilSelecionado.setor.codigo) && this?.responseAnalise?.isFluxoBloqueioDinamico) {
        return true
      }
      return false
    },

    showModelo () {
      if (exibirModelos.tipos.includes(this.responseAnalise?.despacho.tipo)) {
        if (naoExibirModelos.perfis.includes(this.usuario?.perfilSelecionado.codigo)) {
          return false
        }
        return true
      }
    },

    possuiTitulo () {
      return possuiTitulo.acoes.includes(this.responseAnalise?.despacho.acao)
    },

    montarDecisoes () { // utilizar esse metodo para setar as label das decisões(aplicar regra)
      if (decisoes[this.usuario?.perfilSelecionado.setor.codigo]) {
        return decisoes[this.usuario.perfilSelecionado.setor.codigo]
      }
    },

    showButtonsDecisao () {
      return exibirBotoesDecisao.setores.includes(this.usuario?.perfilSelecionado.setor.codigo) || (statusBotoesDecisao.status.includes(this.processo?.status) && statusBotoesDecisao.perfis.includes(this.usuario?.perfilSelecionado.codigo))
    },

    setActive (active) {
      this.active = active
    }
  },

  computed: {
    // Retorna as regras de negócio da tela de análise
    isNdiBa () {
      return this.usuario?.perfilSelecionado.setor.codigo === 'NDI' && process.env.ESTADO === 'ba'
    },
    regras () {
      return {
        showAnaliseAutomatizada: this.showAnaliseAutomatizada(),
        podeInserirAnotacao: this.podeInserirAnotacao(),
        showButtonsDecisao: this.showButtonsDecisao(),
        showMapa: this.showMapa(),
        showModelo: this.showModelo(),
        possuiTitulo: this.possuiTitulo(),
        decisoes: this.montarDecisoes(),
        showArquivosBloqueio: this.showArquivosBloqueio(),
        showArquivosMonitoramento: this.showArquivosMonitoramento()
      }
    }

  }
}

</script>



// WEBPACK FOOTER //
// src/screens/analise/AnalisarValidarProcessoDefault.vue